import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fa } from 'vuetify/locale'
import { aliases, custom } from './icons'

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    rtl: { fa: true },
    locale: 'fa',
    messages: {
      fa,
    },
  },
  icons: {
    defaultSet: 'custom',
    aliases,
    sets: {
      custom,
    },
  },

  defaults: {
    VTextField: {
      variant: 'outlined',
      color: 'primary',
      density: 'comfortable',
      rounded: 'lg',
    },
    VAutocomplete: {
      variant: 'outlined',
      color: 'primary',
      density: 'comfortable',
      rounded: 'lg',
    },
    VTextarea: {
      variant: 'outlined',
      color: 'primary',
      density: 'comfortable',
      rounded: 'lg',
    },
    VSelect: {
      variant: 'outlined',
      color: 'primary',
      density: 'comfortable',
      rounded: 'lg',
    },
    VBtn: {
      size: 'large',
      color: 'primary',
      style: 'letter-spacing: 0px',
      class: ['rounded-lg elevation-0'],
    },
    VListItem: {
      ripple: false,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          white: '#FFFFFF',
          primary: '#96672C',
          'primary-600': '#96672C',
          'primary-700': '#96672C',
          'primary-800': '#0F5D66',
          'primary-900': '#094554',
          secondary: '#424242',
          accent: '#242468',
          error: '#C65468',
          'error-100': '#F4DDE1',
          'error-600': '#AA3D5A',
          'error-700': '#8E2A4E',
          info: '#4D81E7',
          success: '#82AD0C',
          // set base theme color gray-600 with opacity dont change this
          'on-surface': '#2B2E31',
          'success-100': '#E6EFCE',
          'success-600': '#6B9408',
          'success-700': '#567C06',
          warning: '#FFC600',
          'warning-600': '#D69F05',
          'gray-50': '#E2E3E4',
          'gray-100': '#EDF1F3',
          'gray-200': '#DCE4E8',
          'gray-300': '#ACB5BB',
          'gray-300-20': '#2A5B69',
          'gray-400': '#6C7278',
          'gray-500': '#404040',
          'gray-600': '#2B2E31',
          'gray-700': '#0D1015',
          'gray-800': '#080B11',
          'gray-900': '#04070E',
          background: '#F4F4F7',

          rhino: '#363672',
        },
      },
    },
  },
})

export default vuetify
